import { FC } from 'react';
import { Grid, Skeleton } from '@mui/material';
import MainCard from 'components/MainCard';
import StatCardSkeleton from './StatCardSkeleton';

const DashboardSkeleton: FC = () => (
  <Grid container rowSpacing={4.5} columnSpacing={2.75}>
    {/* hero */}
    <Grid item xs={12}>
      <Skeleton variant="rounded" width="100%" height={132} />
    </Grid>

    {/* row 1 — stat cards */}
    {Array.from({ length: 4 }).map((_, i) => (
      <Grid item xs={12} sm={6} lg={3} key={i}>
        <StatCardSkeleton />
      </Grid>
    ))}

    <Grid item xs={12} md={8} lg={9}>
      <MainCard>
        <Skeleton variant="text" width={160} height={28} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" width="100%" height={360} />
      </MainCard>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <MainCard>
        <Skeleton variant="text" width={120} height={28} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" width="100%" height={360} />
      </MainCard>
    </Grid>
  </Grid>
);

export default DashboardSkeleton;
